__turbopack_context__.v({
  "block": "landing-module__dM5n-G__block",
  "floatingContact": "landing-module__dM5n-G__floatingContact",
  "landing": "landing-module__dM5n-G__landing",
  "page-progress": "landing-module__dM5n-G__page-progress",
  "scrollProgress": "landing-module__dM5n-G__scrollProgress",
});
